import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap, switchMapTo } from "rxjs/operators";
import { selectAllExistingBuildingInfo } from "../../../selectors/selectExistingBuildingInfo";
import { selectIsModalOpen } from "../../../selectors/selectModalTabId";
import { utilBuildings } from "../../../utils/utilBuildings";
import { utilTick } from "../../../utils/utilTick";
import { utilTime } from "../../../utils/utilTime";
import { TypeActionApp } from "../../app/actionApp";
import { actionProductionInfoFinishProduction } from "../../info/production/actionProductionInfo";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionOngoingPurchaseCloseAll } from "../../ongoing-purchase/actionOngoingPurchase";
import { actionBuildingsSelectForData } from "../../player-base/buildings/actionBuildings";
export var epicTimeProduction = function (action$, state$) {
    return action$.pipe(ofType(TypeActionApp.Init), switchMapTo(utilTick.second$), switchMap(function () {
        var state = state$.value;
        var _a = state.playerBase.buildings, selectedBuilding = _a.building, buildingCenterCoords = _a.buildingCenterCoords;
        var actions = [];
        selectAllExistingBuildingInfo(state)
            .filter(utilBuildings.isProducing)
            .forEach(function (building) {
            var timeLeft = utilTime.secondsLeftTill(building.production.production.remainingTime);
            if (timeLeft <= 0) {
                if (selectedBuilding && selectedBuilding.proto.id === building.proto.id) {
                    if (selectIsModalOpen(state, IdModal.NotEnoughResource)) {
                        if (selectIsModalOpen(state, IdModal.SpendGoldConfirmation)) {
                            actions.push(actionModalClose(IdModal.SpendGoldConfirmation));
                        }
                        actions.push(actionModalClose(IdModal.NotEnoughResource));
                        actions.push(actionOngoingPurchaseCloseAll());
                    }
                    actions.push(actionBuildingsSelectForData(selectedBuilding, buildingCenterCoords));
                }
                actions.push(actionProductionInfoFinishProduction(building.proto.id));
            }
        });
        return from(actions);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/time/epics/epicTimeProduction.ts
// module id = 2437
// module chunks = 3